import { keepPreviousData } from "@tanstack/react-query";
import { useCapitalActivityTableDataRetrieve } from "gen/endpoints/capital-activity/capital-activity";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingState } from "shared/components/empty/LoadingState";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { EqualizedViewToggleButton } from "shared/components/toggle/EqualizedViewToggleButton";

export const InvestmentEntityTabActivity: React.FC<{
  fundFamilyId: string;
  investmentEntityIds: string[]; // may be either portfolios or investments
}> = ({ fundFamilyId, investmentEntityIds }) => {
  const { t } = useTranslation(["investment", "common"]);
  const [isEqualizedView, setIsEqualizedView] = useState<boolean>(false);
  const { data: tableData, isFetching } = useCapitalActivityTableDataRetrieve(
    {
      fund_family_ids: [fundFamilyId],
      investment_entity_ids: investmentEntityIds,
      is_equalized_view: isEqualizedView,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );

  return (
    <PageTabBody>
      <TableBox>
        <TableBoxHeader>
          <TableBoxTitle>{t("common:capitalActivity")}</TableBoxTitle>
          <DataTableBoxActions>
            <EqualizedViewToggleButton
              isEqualizedView={isEqualizedView}
              setIsEqualizedView={setIsEqualizedView}
            />
          </DataTableBoxActions>
        </TableBoxHeader>
        <TableBoxBody>
          {tableData ? (
            <DataTable
              data={tableData}
              isLoading={isFetching}
              emptyStateProps={{
                title: t("investment:tabs.activity.table.empty.title"),
                description: t(
                  "investment:tabs.activity.table.empty.description",
                ),
              }}
            />
          ) : (
            <LoadingState />
          )}
        </TableBoxBody>
      </TableBox>
    </PageTabBody>
  );
};
